import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { ArcRoutes } from '../../../pages/arc/constants/routes';
import { BillingAccount } from '../../../pages/arc/features/billing-accounts/billing-accounts-models';
import { TcsmStates } from '../../../root/tcsm-model';
import { useBasePath } from '../../hooks/useBasePath';

export const withBillingAccountSelect = () => (WrappedComponent: React.ComponentType<any>) => {
	return (props: React.PropsWithChildren<any>) => {
		const location = useLocation();
		const billingAccountSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}`);
		const billingAccount = useSelector<TcsmStates, BillingAccount>(state => state?.billingAccountsState?.currentBillingAccount);
		if (!billingAccount) {
			return (
				<Redirect to=
					{
						{
							pathname: billingAccountSelect,
							state: {
								finalAction: location.pathname,
							},
						}
					}
				/>);
		}
		return (<WrappedComponent {...props}>
			{props.children}
		</WrappedComponent>);

	};
};
